/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Determine if a node is a DetachedSequenceId.
 * @internal
 */
// Nodes can be an `object` type which is a banned type.
export function isDetachedSequenceId(node) {
    return typeof node !== 'object';
}
//# sourceMappingURL=Identifiers.js.map